import type {ComponentType} from 'react'
import {connect} from 'react-redux'

import type {State} from '../../../../../reducers/types'
import {getBuildLogMessagesReady, getFullLogState} from '../../BuildLog.selectors'
import {getKeyForBuildLogData} from '../../BuildLog.utils'
import {navigateToFirstMessage, navigateToLastMessage} from '../FullBuildLog.actions'

import BuildLogNavigation from './BuildLogNavigation'
import type {OwnProps, StateProps, ActionProps} from './BuildLogNavigation.types'

const actionCreators: ActionProps = {
  navigateToFirstMessage,
  navigateToLastMessage,
}

const mapStateToProps = (state: State, {target}: OwnProps): StateProps => {
  const {showedFirstId, showedLastId, scrollBarInfo, messagesExists} = getFullLogState(
    state,
    target,
  )
  const buildLogKey = getKeyForBuildLogData({
    type: 'full',
    target,
  })
  return {
    ready: getBuildLogMessagesReady(state, buildLogKey),
    scrollBarSize: scrollBarInfo?.size,
    scrollBarHorizontal: scrollBarInfo?.horizontal ?? false,
    scrollBarVertical: scrollBarInfo?.vertical ?? false,
    showedFirstId,
    showedLastId,
    messagesExists,
  }
}

export default connect(
  mapStateToProps,
  actionCreators,
)(BuildLogNavigation) as ComponentType<OwnProps>
